import __base_store from '@/store/__base_store'

/**
 * Store de reputación de cliente (modelo `client_reputation`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'client_reputation',
	},
})

